import { differenceInHours, isValid, parseISO } from 'date-fns';

export function isWithinD0Window(isoTimestamp: string | null | undefined): boolean {
	if (!isoTimestamp) {
		return false;
	}
	const parsed = parseISO(isoTimestamp);
	return isValid(parsed) && differenceInHours(new Date(), parsed) < 24;
}

export function isWithinD0WindowEpoch(epochMs: number): boolean {
	const date = new Date(epochMs);
	return isValid(date) && differenceInHours(new Date(), date) < 24;
}
